import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { AdminSetupEditSchoolDayComponent } from "./admin-setup-edit-school-day/admin-setup-edit-school-day.component";
import { DataService_SchoolDaySetup } from "./shared/data.service";

@Component({
	selector: "app-school-day-setup",
	templateUrl: "./school-day-setup.component.html",
	styleUrls: ["./school-day-setup.component.css"],
})
export class SchoolDaySetupComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private userService: UserService,
		private SchoolDaySetupService: DataService_SchoolDaySetup,
		private dialogService: DialogService,
		private schoolService: SchoolService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		// this.loadSchools();
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	subscription: any;

	MoveUpDisabled: any = true;
	MoveDownDisabled: any = true;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////
	School: any;
	lstSchool: any = [];

	//Main
	SelectedSchoolDay: any;
	lstSchoolDay: any = [];

	//Filter lists
	lstDefault_BellScheduleDesc: any = [];
	lstSchoolName: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "DayDesc", header: "Description" },
		{ field: "DayCD", header: "Code" },
		{ field: "Default_BellScheduleDesc", header: "Default Bell Schedule" },
		{ field: "SchoolName", header: "Available To" },
		{ field: "ZOrder", header: "Order" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////
	// loadSchools(){
	//   var result = this.schoolService.loadSchoolList("");
	//   result.subscribe(
	//       response => {
	//           this.lstSchool = response;
	//           this.SchoolID = this.lstSchool[0].SchoolID;

	//           this.loadSchoolDay();
	//       },
	//       error => {
	//       }
	//   )
	// }

	loadSchoolDay() {
		this.errorMessage = "";

		if (this.School == undefined) {
			return;
		}

		this.loading = true;

		var result = this.SchoolDaySetupService.LoadSchoolDay(this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstSchoolDay = response;

				// for(var i = 0; i < this.lstSchoolDay.length; i++){
				//   var next = this.lstSchoolDay[i];

				//   next.SchoolName = next.SchoolID == 0 ? "District" : this.GetSchoolName(next.SchoolID);
				// }

				//Load Data Filter Lists
				this.lstDefault_BellScheduleDesc = Array.from(new Set(this.lstSchoolDay.map((item: any) => item.Default_BellScheduleDesc))).sort();
				this.lstSchoolName = Array.from(new Set(this.lstSchoolDay.map((item: any) => item.SchoolName))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	// GetSchoolName(sID){
	//   var ans = "";

	//   for(var i = 0; i < this.lstSchool.length; i++){
	//     var next = this.lstSchool[i];

	//     if(next.SchoolID == sID){
	//       ans = next.SchoolName;
	//       break;
	//     }

	//   }

	//   return ans;
	// }

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadSchoolDay();
	}

	//Custom Button Methods
	onEditSchoolDay() {
		this.errorMessage = "";

		if (this.SelectedSchoolDay == undefined) {
			this.errorMessage = "Select a school day to edit";
			return;
		}

		// Only SU and District users can edit district defined school days
		if (this.user.userID != 0 && this.user.UserLevelID == 3 && this.SelectedSchoolDay.SchoolID == 0) {
			this.errorMessage = "School users cannot edit district defined school days";
			return;
		}

		//
		//	10.16, only Daily is System-Defined?
		//		In 10.15 all Days are imported as System-Defined
		//		(But schools want to edit them or add a default bell schedule)
		//
		if (this.SelectedSchoolDay.DayID <= 0) {
			this.errorMessage = "Cannot edit system defined school days";
			return;
		}

		var ref = this.dialogService.open(AdminSetupEditSchoolDayComponent, {
			header: "Edit School Day",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SchoolID: this.School.SchoolID,
				SelectedSchoolDay: this.SelectedSchoolDay,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadSchoolDay();
			}
		});
	}

	onMoveUp() {
		this.errorMessage = "";

		//
		// Sort list by ZOrder
		//

		var SortedList = this.lstSchoolDay.sort((a, b) => Number(a.ZOrder) - Number(b.ZOrder));

		var nextDay = null;

		//
		// Get the previous Day ID (Must be editable and not system defined)
		//
		for (var i = 0; i < SortedList.length; i++) {
			var next = SortedList[i];

			if (next.DayID == this.SelectedSchoolDay.DayID) {
				nextDay = SortedList[i - 1];
			}
		}

		if (nextDay == null) {
			return;
		}

		if (nextDay.SystemDefinedInd == 1 || (this.user.userID != 0 && this.user.UserLevelID == 3 && nextDay.SchoolID == 0)) {
			this.errorMessage = "User cannot switch order with the next school day";
			return;
		}

		//
		// Call SP on
		//

		var result = this.SchoolDaySetupService.SchoolDayMoveUp(this.SelectedSchoolDay.DayID, nextDay.DayID);
		result.subscribe(
			(response) => {
				if (response) {
					this.loadSchoolDay();

					this.onRowUnselect(null);
				} else {
					//
					// Fail Dialog
					//
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not move the school day up",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onMoveDown() {
		this.errorMessage = "";

		//
		// Sort list by ZOrder
		//

		var SortedList = this.lstSchoolDay.sort((a, b) => Number(a.ZOrder) - Number(b.ZOrder));

		var nextDay = null;

		//
		// Get the previous Day ID (Must be editable and not system defined)
		//
		for (var i = 0; i < SortedList.length; i++) {
			var next = SortedList[i];

			if (next.DayID == this.SelectedSchoolDay.DayID) {
				nextDay = SortedList[i + 1];
			}
		}

		if (nextDay == null) {
			return;
		}

		if (nextDay.SystemDefinedInd == 1 || (this.user.userID != 0 && this.user.UserLevelID == 3 && nextDay.SchoolID == 0)) {
			this.errorMessage = "User cannot switch order with the next school day";
			return;
		}

		//
		// Call SP on
		//

		var result = this.SchoolDaySetupService.SchoolDayMoveDown(this.SelectedSchoolDay.DayID, nextDay.DayID);
		result.subscribe(
			(response) => {
				if (response) {
					this.loadSchoolDay();

					this.onRowUnselect(null);
				} else {
					//
					// Fail Dialog
					//
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not move the school day down",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onCheckValidity() {
		//
		// Calls SP that always returns true?
		//
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedSchoolDay = val.data;

		//
		// User doesn't have access, disable move up and move down
		//
		if (this.SelectedSchoolDay.SystemDefinedInd == 1) {
			this.MoveUpDisabled = true;
			this.MoveDownDisabled = true;
			return;
		} else if (this.user.userID != 0 && this.user.UserLevelID == 3 && this.SelectedSchoolDay.SchoolID == 0) {
			this.MoveUpDisabled = true;
			this.MoveDownDisabled = true;
			return;
		}

		//
		// If there is only 1 School Day, don't let the user move up or down
		//
		else if (this.lstSchoolDay.length > 1) {
			//
			// Move up (Z Order goes down)
			//
			// Disable if ZOrder is minimum
			//

			var Min = this.SelectedSchoolDay.ZOrder;

			//
			// Move Down (Z Order goes up)
			//
			// Disable if maximum
			//

			var Max = this.SelectedSchoolDay.ZOrder;

			for (var i = 0; i < this.lstSchoolDay.length; i++) {
				var next = this.lstSchoolDay[i];

				if (next.ZOrder < Min) {
					Min = next.ZOrder;
				}

				if (next.ZOrder > Max) {
					Max = next.ZOrder;
				}
			}

			if (Number(this.SelectedSchoolDay.ZOrder) == Number(Min)) {
				this.MoveUpDisabled = true;
			} else {
				this.MoveUpDisabled = false;
			}

			if (Number(this.SelectedSchoolDay.ZOrder) == Number(Max)) {
				this.MoveDownDisabled = true;
			} else {
				this.MoveDownDisabled = false;
			}

			return;
		} else {
			this.MoveUpDisabled = true;
			this.MoveDownDisabled = true;
			return;
		}
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedSchoolDay = null;

		this.MoveUpDisabled = true;
		this.MoveDownDisabled = true;
	}
	onRowDblClick(SchoolDay) {
		this.errorMessage = "";

		this.SelectedSchoolDay = SchoolDay;
		this.onEditSchoolDay();
	}
	onSchoolChange(val) {
		this.errorMessage = "";

		this.School = val;

		this.loadSchoolDay();
	}
	////////////////////////////////////////////
}
